export default __webpack_public_path__ + "static/media/gedeelde-visie.8378325f.svg";